export const letterY = {
  nouns: [],
  verbs: [],
  examples: {
    nominative: [],
    accusative: [],
    dative: [],
    translations: [],
    conjugations: []
  }
}
